module.exports = __webpack_public_path__ + "img/swap-circle-small.2d28e8ad.svg";